import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone, Scale } from "lucide-react";
import { contactInfo } from "../mock";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/#services", label: "Practice Areas" },
  { to: "/#team", label: "Attorneys" },
  { to: "/#appointment", label: "Appointment" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (to) => {
    setOpen(false);
    if (to.includes("#") && location.pathname === "/") {
      const id = to.split("#")[1];
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {/* Top bar */}
      <div className="hidden md:block bg-[#0e1b34] text-[#e6d9b8] text-xs">
        <div className="container-x flex items-center justify-between h-9">
          <div className="flex items-center gap-4">
            <span className="opacity-80">Advocates &amp; Solicitors - Mumbai</span>
          </div>
          <div className="flex items-center gap-4">
            <a href={`tel:${contactInfo.phone}`} className="flex items-center gap-1.5 hover:text-white transition-colors">
              <Phone size={12} /> {contactInfo.phone}
            </a>
            <span className="opacity-70">Mon - Sat: 10:00 AM - 10:00 PM</span>
          </div>
        </div>
      </div>

      <header
        className={`sticky top-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-white/95 backdrop-blur shadow-md"
            : "bg-white/90 backdrop-blur"
        }`}
      >
        <div className="container-x flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-11 h-11 rounded-sm bg-[#0e1b34] flex items-center justify-center border border-[#c9a961]">
              <Scale className="text-[#c9a961]" size={22} />
            </div>
            <div className="leading-tight">
              <div className="font-serif-display text-[#0e1b34] text-xl font-bold tracking-wide">
                Pravin Gupta
              </div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#b28e42] font-semibold">
                & Associates
              </div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => handleNavClick(l.to)}
                className={`nav-link text-sm font-medium text-[#0e1b34] hover:text-[#b28e42] transition-colors ${
                  location.pathname === l.to ? "active" : ""
                }`}
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a href={`tel:${contactInfo.phone}`} className="btn-gold">
              <Phone size={14} /> Call Now
            </a>
          </div>

          <button
            className="lg:hidden text-[#0e1b34] p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden bg-white border-t border-neutral-200 shadow-lg">
            <div className="container-x py-4 flex flex-col gap-1">
              {navLinks.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  onClick={() => handleNavClick(l.to)}
                  className="py-3 px-2 text-[#0e1b34] font-medium border-b border-neutral-100 hover:bg-neutral-50"
                >
                  {l.label}
                </Link>
              ))}
              <a href={`tel:${contactInfo.phone}`} className="btn-gold mt-3 justify-center">
                <Phone size={14} /> {contactInfo.phone}
              </a>
            </div>
          </div>
        )}
      </header>
    </>
  );
}
